// extracted by mini-css-extract-plugin
module.exports = {"ButtonGroup":"Footer__ButtonGroup___1Fd8j","Button":"Footer__Button___3DzfH"};